module.exports = __webpack_public_path__ + "assets/images/logo-intro_00b322d546c7c7e39063f3456467f6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-intro.png
// module id = 121
// module chunks = 0